import React, { useState } from "react";
import { Paper, Typography, Box, Slider, Grid } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";

const WizualizacjaArkusza = ({ arkusz, wyniki }) => {
  const [zoom, setZoom] = useState(1);
  const [selectedArkusz, setSelectedArkusz] = useState(0);

  const skalowanie = 0.3 * zoom; // Skala do wizualizacji

  const renderArkusz = (arkuszData, index) => {
    return (
      <Box key={index} sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Arkusz {index + 1} - Wykorzystanie: {arkuszData.wykorzystanie}%
        </Typography>

        <Paper
          elevation={2}
          sx={{
            position: "relative",
            width: arkuszData.szerokosc * skalowanie,
            height: arkuszData.wysokosc * skalowanie,
            backgroundColor: "#f5f5f5",
            border: "2px solid #333",
            overflow: "hidden",
            margin: "0 auto",
          }}
        >
          {arkuszData.formatki.map((formatka, idx) => (
            <Box
              key={idx}
              sx={{
                position: "absolute",
                left: formatka.x * skalowanie,
                top: formatka.y * skalowanie,
                width: formatka.szerokosc * skalowanie,
                height: formatka.wysokosc * skalowanie,
                backgroundColor: formatka.obrocony ? "#4caf50" : "#2196f3",
                opacity: 0.8,
                border: "1px solid #000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "0.7rem",
                color: "white",
                fontWeight: "bold",
                "&:hover": {
                  opacity: 1,
                  border: "2px solid #ff9800",
                  zIndex: 1000,
                },
              }}
              title={`${formatka.id}\n${formatka.szerokosc / 10}×${formatka.wysokosc / 10} cm`}
            >
              <div>
                <div>{formatka.id.split("_")[0]}</div>
                <div>{`${formatka.szerokosc / 10}×${formatka.wysokosc / 10} cm`}</div>
              </div>
            </Box>
          ))}
        </Paper>

        <Box sx={{ mt: 1, textAlign: "center" }}>
          <Typography variant="caption" color="text.secondary">
            {arkuszData.szerokosc / 10} × {arkuszData.wysokosc / 10} cm
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <ZoomOutIcon sx={{ mr: 1 }} />
        <Slider
          value={zoom}
          onChange={(e, val) => setZoom(val)}
          min={0.5}
          max={2}
          step={0.1}
          sx={{ width: 200, mx: 2 }}
        />
        <ZoomInIcon sx={{ ml: 1 }} />
        <Typography variant="body2" sx={{ ml: 2 }}>
          Powiększenie: {zoom.toFixed(1)}x
        </Typography>
      </Box>

      {wyniki.arkusze.length > 1 && (
        <Box sx={{ mb: 3 }}>
          <Typography gutterBottom>Wybierz arkusz do wyświetlenia:</Typography>
          <Grid container spacing={1}>
            {wyniki.arkusze.map((_, index) => (
              <Grid item key={index}>
                <Paper
                  elevation={selectedArkusz === index ? 3 : 1}
                  onClick={() => setSelectedArkusz(index)}
                  sx={{
                    p: 1,
                    cursor: "pointer",
                    backgroundColor:
                      selectedArkusz === index ? "#e3f2fd" : "white",
                    "&:hover": { backgroundColor: "#f5f5f5" },
                  }}
                >
                  Arkusz {index + 1}
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {wyniki.arkusze.length === 1
        ? renderArkusz(wyniki.arkusze[0], 0)
        : renderArkusz(wyniki.arkusze[selectedArkusz], selectedArkusz)}
    </Box>
  );
};

export default WizualizacjaArkusza;
